import React from "react";

const Button = ({ children, className, ...rest }) => {
    return <button className={`select-none flex justify-center items-center font-bold text-sm rounded-md py-2 px-2 text-white bg-blue-500 hover:bg-blue-800 
  ${className}`}
        {...rest} >
        {children}
    </button>
}

export default Button;